import { graphql } from '@eluve/graphql.tada';

export const searchTenantUsersInvitesQuery = graphql(`
  query searchTenantUsersInvites(
    $filter: CombinedTenantUsersInvitesBoolExp
    $offset: Int
    $orderBy: [CombinedTenantUsersInvitesOrderBy!]
    $limit: Int
  ) {
    combinedTenantUsersInvites(
      where: $filter
      offset: $offset
      limit: $limit
      orderBy: $orderBy
    ) {
      __typename
      inviteId
      userId
      firstName
      lastName
      email
      status
      role
      createdAt
      lastAccessedAt
      isExpired
    }
    combinedTenantUsersInvitesAggregate(where: $filter) {
      aggregate {
        count
      }
    }
  }
`);

export const removeTenantUserMutation = graphql(`
  mutation RemoveTenantUser($tenantId: uuid!, $userId: uuid!) {
    deleteTenantUsersByPk(tenantId: $tenantId, userId: $userId) {
      __typename
      tenantId
      userId
    }
  }
`);

export const updateTenantUserRoleMutation = graphql(`
  mutation UpdateUserTenantRole(
    $tenantId: uuid!
    $userId: uuid!
    $role: String!
  ) {
    updateTenantUsersByPk(
      pkColumns: { tenantId: $tenantId, userId: $userId }
      _set: { role: $role }
    ) {
      __typename
      tenantId
      userId
      role
    }
  }
`);
